// extracted by mini-css-extract-plugin
export default {"popup":"popup___gJAde9a","tabs":"tabs___gJAde9a","tab":"tab___gJAde9a","active":"active___gJAde9a"};